/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { ReleasePreviewThin } from './ThinPreview';
import { BasicInfo } from './BasicInfo';
import { Finished } from './Finished';
import { PreviewBackground } from './PreviewBackground';
import styles from './index.module.css';
import { Fade } from '../../../vendor/Motion/Fade';
import { PreviewPanePodcast } from '../../../types';
import { RouteComponentProps } from 'react-router';

const PREVIEW_THIN = 'PREVIEW_THIN';
export const PREVIEW_CELEBRATION = 'PREVIEW_CELEBRATION';
export const PANEL_WIDTH = parseInt(styles.panelwidth, 10);
const ANIMATION_DELAY = parseInt(styles.sidepanelduration, 10);

interface Props extends Pick<RouteComponentProps, 'history' | 'location'> {
  rssFeed: PreviewPanePodcast | null;
  previewMode?: string;
  existingPodcast: boolean;
  unsetSubmitFeedStatus: () => void;
  loadMe: () => void;
  shouldFadeIn?: boolean;
}

interface State {
  panelOffsetX: number;
}

export class AnimatedReleasePreview extends PureComponent<Props, State> {
  static propTypes = {
    rssFeed: PropTypes.shape({
      title: PropTypes.string,
      image: PropTypes.string,
      description: PropTypes.string,
      language: PropTypes.string,
      itunesCategories: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
        }),
      ),
      isExistingShow: PropTypes.bool,
    }),
    previewMode: PropTypes.string,
    existingPodcast: PropTypes.bool.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({}).isRequired,
    unsetSubmitFeedStatus: PropTypes.func.isRequired,
    loadMe: PropTypes.func.isRequired,
    shouldFadeIn: PropTypes.bool,
  };
  static defaultProps = {
    rssFeed: {},
    shouldFadeIn: true,
  };

  state = {
    panelOffsetX: window.innerWidth - PANEL_WIDTH,
  };

  scrollableContainer = React.createRef<HTMLDivElement>();

  componentDidMount() {
    this.setPanelOffset();
    window.addEventListener('resize', this.setPanelOffset);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    /* istanbul ignore next */
    if (
      nextProps.previewMode !== this.props.previewMode &&
      this.scrollableContainer.current &&
      this.scrollableContainer.current.scroll
    ) {
      this.scrollableContainer.current.scroll(0, 0);
    }
  }

  componentWillUnmount() {
    /* istanbul ignore next */
    window.removeEventListener('resize', this.setPanelOffset);
  }
  setPanelOffset = () => {
    this.setState({ panelOffsetX: window.innerWidth - PANEL_WIDTH });
  };

  render() {
    const { rssFeed, previewMode } = this.props;
    const { panelOffsetX } = this.state;

    const showThinPreview = previewMode === PREVIEW_THIN;
    const thinTransitionProps = {
      in: showThinPreview,
      unmountOnExit: true,
      timeout: ANIMATION_DELAY,
      exit: false,
    };

    const showCelebration = previewMode === PREVIEW_CELEBRATION;
    const celebrationTransitionProps = {
      in: showCelebration,
      unmountOnExit: true,
      timeout: ANIMATION_DELAY,
      exit: false,
    };

    return (
      <section
        className={cn(
          styles.animated_preview_panel,
          !showCelebration && styles.animated_preview_panel__thin,
          showCelebration && styles.celebration,
        )}
        style={{
          transform: showCelebration ? `translate(0, 0)` : `translate(${panelOffsetX}px, 0)`,
        }}
      >
        <div
          ref={this.scrollableContainer}
          className={cn(styles.scrollable, showCelebration && styles.celebration)}
        >
          <div className={styles.release_info}>
            <section className={styles.release_info_left}>
              <div>
                <BasicInfo
                  rssFeed={rssFeed}
                  panelOffset={panelOffsetX}
                  className={cn(
                    showCelebration && styles.basic_info_container__fullscreen,
                    !showCelebration && styles.basic_info_container__thin,
                  )}
                  showCelebration={showCelebration}
                />
              </div>
              <Fade {...thinTransitionProps}>
                <ReleasePreviewThin rssFeed={rssFeed} />
              </Fade>
            </section>
            <section className={styles.release_celebration}>
              <Fade {...celebrationTransitionProps}>
                <Finished {...this.props} />
              </Fade>
            </section>
          </div>
        </div>
        <PreviewBackground
          coverArtImagePath={rssFeed ? rssFeed.image : ''}
          showCelebration={previewMode === PREVIEW_CELEBRATION}
          shouldFadeIn={this.props.shouldFadeIn}
        />
      </section>
    );
  }
}
